import { db, storage } from "../firebase/config";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  onSnapshot
} from "firebase/firestore";

export function subscribeToPartners(callback) {
  return onSnapshot(collection(db, "partners"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    list.sort((a, b) => a.name.localeCompare(b.name));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to partners:", error);
    callback([], error);
  });
}

export function subscribeToPartnerCategories(callback) {
  return onSnapshot(collection(db, "partner_categories"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    list.sort((a, b) => a.name.localeCompare(b.name));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to partner categories:", error);
    callback([], error);
  });
}

export async function addPartner(data) {
  const partnerData = {
    name: data.name || "",
    categoryName: data.categoryName || "",
    pocs: data.pocs || [],
    attachments: data.attachments || [],
    createdAt: new Date().toISOString()
  };
  const docRef = await addDoc(collection(db, "partners"), partnerData);
  return docRef.id;
}

export async function updatePartner(id, data) {
  const docRef = doc(db, "partners", id);
  await updateDoc(docRef, data);
}

export async function deletePartner(id) {
  const docRef = doc(db, "partners", id);
  await deleteDoc(docRef);
}

export async function uploadPartnerAttachment(partnerId, file, type, uploadedBy) {
  const timestamp = Date.now();
  const filePath = `partners/${partnerId}/${timestamp}_${file.name}`;
  const fileRef = ref(storage, filePath);
  
  await uploadBytes(fileRef, file);
  const downloadUrl = await getDownloadURL(fileRef);
  
  return {
    id: timestamp.toString(),
    name: file.name,
    url: downloadUrl,
    path: filePath,
    type: type || "Other",
    uploadedBy: uploadedBy || "Unknown",
    timestamp: new Date().toISOString()
  };
}

export async function deletePartnerAttachment(filePath) {
  const fileRef = ref(storage, filePath);
  await deleteObject(fileRef);
}
